<template>
    <div class="container-fluid sliderWrapper">
        <div class="row">
            <div class="container sliderContent">
                <div class="slider sliderMain" ref="slider">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Slider",
        created() {
            let vm = this
            this.$nextTick(function () {
                $(vm.$refs.slider).slick({
                    centerMode: false,
                    centerPadding: '0px',
                    slidesToShow: 7,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                arrows: true,
                                centerMode: false,
                                centerPadding: '0px',
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                arrows: true,
                                centerMode: false,
                                centerPadding: '0px',
                                slidesToShow: 3
                            }
                        }
                    ]
                });
            })
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>